<template>
  <FormModal
    title="Vul je gegevens aan"
    next-btn-text="Vergelijk nu"
    show-back-btn
  >
    <template #body>
      <ContactInformationFormStep :progress-value="progressValue" />
    </template>
  </FormModal>
</template>

<script>
import FormModal from 'chimera/all/themes/blueflow/components/layout/FormModal'
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import ContactInformationFormStep from '~/components/form/steps/contactInformation/ContactInformationFormStep'

export default {
  components: {
    FormModal,
    ContactInformationFormStep,
  },

  extends: AbstractFormPage,

  layout: 'form',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Je gegevens',
      headDescription:
        'Vul je gegevens aan, zodat we je in contact kunnen brengen met de best geschikte leveranciers uit jouw regio.',
      path: '/offertes-aanvragen/je-gegevens',
      checkoutStep: 4,
      progressValue: 80,
    }
  },
}
</script>
